<script setup lang="ts">
import type { PropType } from 'vue';
import { getApiRoot } from '~/utilities/api';

const props = defineProps({
  compact: { type: Boolean, required: true },
  offer: { type: Object as PropType<any>, required: true },
});
const { compact, offer } = toRefs(props);

const timeout = (ms: number) => new Promise((_resolve, reject) => setTimeout(() => reject(new Error('Time out!')), ms));

const { connect, session, pairings, takeOffer } = await useWalletConnect();
const waitingForConfirmation = ref(false);

const takeOfferSuccess = ref(false);
const takeOfferFailed = ref(false);
const takeOfferUsingWalletConnect = async () => {
  try {
    useTrackEvent('offer_walletconnect');
    const offerBech32 = await $fetch<any>(`${getApiRoot()}/offers/${offer.value.id}/bech32`);
    const { status } = await $fetch<any>(`https://api.dexie.space/v1/status`);

    if (offerBech32) {
      waitingForConfirmation.value = true;
      const { valid } = (await Promise.race([
        takeOffer(offerBech32, status?.fees?.recommended || 0),
        timeout(60000),
      ])) as any;
      if (valid) {
        takeOfferSuccess.value = true;
      } else {
        takeOfferFailed.value = true;
      }
    } else {
      takeOfferFailed.value = true;
    }
  } catch (e) {
    takeOfferFailed.value = true;
  } finally {
    waitingForConfirmation.value = false;
  }
};
</script>
<template>
  <div>
    <DetailsWalletConnectButton
      v-if="session && pairings?.length > 0"
      :show-spinner="waitingForConfirmation"
      :compact="compact"
      :title="$t('offers.takeOffer')"
      @click.prevent="takeOfferUsingWalletConnect"
    >
      <template v-if="!compact">{{ $t('offers.takeOffer') }}</template>
    </DetailsWalletConnectButton>
    <DetailsWalletConnectButton v-else :compact="compact" :title="$t('offers.connectWallet')" @click.prevent="connect">
      <template v-if="!compact">{{ $t('offers.connectWallet') }}</template>
    </DetailsWalletConnectButton>
  </div>
</template>
